import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import InputDropdown from 'components/InputDropdown';
import Titulo from 'components/Titulo';
import DadosPessoa from './pessoa';
import DadosPessoaJuridica from './pessoaJuridica';
import { ENUM_TIPO_PESSOA } from 'utils/consts';

export default function FormPessoa({
  control,
  onChange,
  errors,
  getValues,
  watch,
  disabled,
  verificarRepeticao,
  disableDocumento,
}) {
  return (
    <>
      <Row>
        <Titulo textTitle={'Dados Pessoais'} />
        <InputDropdown
          name="tipoPessoa"
          errors={errors}
          control={control}
          onChange={onChange}
          options={[ENUM_TIPO_PESSOA.fisica, ENUM_TIPO_PESSOA.juridica]}
          disabled={disabled || disableDocumento}
          value={watch('tipoPessoa')}
        />
      </Row>
      <DadosPessoa
        control={control}
        onChange={onChange}
        errors={errors}
        tipoPessoaSelecionada={watch('tipoPessoa')}
        disabled={disabled}
        getValues={getValues}
        verificarRepeticao={verificarRepeticao}
        disableDocumento={disableDocumento}
      />
      {watch('tipoPessoa') === ENUM_TIPO_PESSOA.juridica.descricao && (
        <DadosPessoaJuridica
          control={control}
          onChange={onChange}
          errors={errors}
          disabled={disabled}
          verificarRepeticao={verificarRepeticao}
          disableDocumento={disableDocumento}
        />
      )}
    </>
  );
}

FormPessoa.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  getValues: PropTypes.func,
  setError: PropTypes.func,
  salvarAquivos: PropTypes.func,
  disabled: PropTypes.bool,
};
